import React from 'react';
import { ImageCarousel } from './ImageCarousel';
import { Eye } from 'lucide-react';
const PREVIEW_IMAGES = ['https://cdn.magicpatterns.com/uploads/dUZ1s4A7DHCv2MUZ6QPXkN/Diseno_sin_titulo-50.png', 'https://cdn.magicpatterns.com/uploads/i5tsZPNHGzPS2fDc3Foeit/Diseno_sin_titulo-49.png', 'https://cdn.magicpatterns.com/uploads/j1vsVbbtguKM56ReehDVVz/Diseno_sin_titulo-48.png', 'https://cdn.magicpatterns.com/uploads/vAD4HtWmk3CBVi7YQxedgJ/Diseno_sin_titulo-47.png'];
export function PreviewSection() {
  return <section className="py-12 md:py-16 px-4 bg-gray-50" data-id="element-270">
      <div className="max-w-3xl mx-auto" data-id="element-271">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-272">
          <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-600 px-5 py-2 rounded-full text-sm font-semibold mb-4" data-id="element-273">
            <Eye className="w-4 h-4" data-id="element-274" />
            MIRÁ POR DENTRO
          </div>
          <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-2" data-id="element-275">
            Páginas reales del material
          </h2>
          <p className="text-base md:text-lg text-gray-600" data-id="element-276">
            Proyectos paso a paso, clases listas y actividades prácticas
          </p>
        </div>

        {/* Carousel */}
        <div className="rounded-2xl overflow-hidden shadow-xl border border-gray-200" data-id="element-277">
          <ImageCarousel images={PREVIEW_IMAGES} autoPlayInterval={5000} data-id="element-278" />
        </div>

        {/* Swipe hint for mobile */}
        <p className="text-center text-sm text-gray-400 mt-3 md:hidden" data-id="element-279">
          ← Deslizá para ver más →
        </p>
      </div>
    </section>;
}